import catalogue from '../data/frame-clearance.json';

export function frameClearance(frame, groupset) {
  if (frame && frame.name === 'Allied ABLE (2026)') return { name: frame.name, minMm: 45, maxMm: 57, source: 'https://alliedcycleworks.com/products/able-frameset-custom' };
  if (frame && frame.name === 'Allied ECHO (2026)') return { name: frame.name, maxMm: 45, source: 'https://cadenceintl.com/products/allied-echo-frameset' };
  if (frame && /^3T Extrema Italia\b/.test(frame.name)) return { name: frame.name, maxMm: 57, source: 'https://3t.bike/collections/extrema-italia', note: 'Designed around 47–57 mm measured width.' };
  if (frame && /^Avona Callis 32\b/.test(frame.name)) return { name: frame.name, maxMm: 55, source: 'https://www.velodrom.cc/products/avona-callis-32-frameset-deep-olive', note: 'Optimised for 50–55 mm 32" tyres; 55 mm leaves 6 mm clearance.' };
  const entry = frame && catalogue.frames[frame.id];
  if (!entry || !(frame.name || '').toLowerCase().startsWith(entry.name.toLowerCase())) return null;
  const result = { ...entry };
  const drive = groupset && groupset.name || '';
  if (entry.twoByMax) {
    if (/\b2x\b/i.test(drive)) {
      if (!entry.twoByPattern || new RegExp(entry.twoByPattern, 'i').test(drive)) result.maxMm = entry.twoByMax;
      else result.review = true;
    } else if (!/\b1x\b|xplr/i.test(drive)) result.review = true;
  }
  return result;
}

export function tyreFit(frame, groupset, width) {
  const clearance = frameClearance(frame, groupset);
  if (!width) return { level: 'warning', text: 'Choose a tyre width to check frame clearance.', clearance };
  if (!clearance) return { level: 'warning', text: 'Tyre clearance is not verified for this frameset. Our team needs to check this combination.', clearance };
  if (clearance.minMm && width < clearance.minMm) return { level: 'error', text: `${width} mm is below ${frame.name}’s recommended ${clearance.minMm} mm minimum. Choose a wider tyre.`, clearance };
  if (clearance.review) return { level: 'warning', text: `Frame clearance needs confirmation. ${clearance.note || 'Confirm the drivetrain configuration before choosing tyre width.'}`, clearance };
  if (clearance.maxMm && width > clearance.maxMm) {
    return { level: 'error', text: `${width} mm exceeds ${frame.name}’s published ${clearance.maxMm} mm limit. Choose a narrower tyre or another frameset.`, clearance };
  }
  if (!clearance.maxMm) {
    return { level: 'warning', text: `Frame clearance needs confirmation. ${clearance.note}`, clearance };
  }
  return { level: 'info', text: `${width} mm is within the published ${clearance.maxMm} mm limit. Actual inflated width depends on the rim; final clearance must be checked on the assembled bike.`, clearance };
}

export function tyreWidths(item, color) {
  const variant = item && item.colors && item.colors[color];
  return variant && variant.tyreWidths || [];
}

export function validTyreWidth(value) {
  const width = Number(value);
  return Number.isFinite(width) && width >= 18 && width <= 80 ? Math.round(width * 10) / 10 : null;
}
